export default {"src":"/_next/static/media/ComplyFlowDark.b96510dc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};